import PreviewFaq from './PreviewFaq'
export default PreviewFaq